<template>
  <div class="trails-overview full-width-container" :class="{'summer-trails-overview' : isSummerResort}">
    <div class="flex-grid">
      <h1 class="title">{{ trailsOverviewTitle }}</h1>
    </div>

    <div class="flex-grid">
      <!-- trails hero -->
      <div class="col data-block main-block" v-if="showTrailsFirst && showTrails">
        <div class="block-text">
          {{ totalOpenTrails }}<span>/{{ totalTrails }}</span>
        </div>
        <div class="block-title">
          <a href="#trails" title="Trails">
            <span tabindex="-1">
              {{ trailsOverviewNames['Trails'] }}
            </span>
          </a>
        </div>
      </div>

      <!-- lifts hero -->
      <div class="col data-block main-block" v-if="showLiftsFirst && showLifts">
        <div class="block-text">
          {{ totalOpenLifts }}<span>/{{ totalLifts }}</span>
        </div>
        <div class="block-title">
          <a href="#lifts" title="Lifts">
            <span tabindex="-1">
              {{ trailsOverviewNames['Lifts'] }}
            </span>
          </a>
        </div>
      </div>

      <!-- trails regular block -->
      <div class="col data-block" v-if="!showTrailsFirst && showTrails">
        <div class="block-title">
          <a href="#trails" title="Trails">
            <span tabindex="-1">
              {{ trailsOverviewNames['Trails'] }}
            </span>
          </a>
        </div>
        <div class="block-text">
          <strong>{{ totalOpenTrails }}</strong>
          <span>/{{ totalTrails }}</span>
        </div>
      </div>

      <!-- lifts regular block -->
      <div class="col data-block" v-if="!showLiftsFirst && showLifts">
        <div class="block-title">
          <a href="#lifts" title="Lifts">
            <span tabindex="-1">
              {{ trailsOverviewNames['Lifts'] }}
            </span>
          </a>
        </div>
        <div class="block-text">
          <strong>{{ totalOpenLifts }}</strong>
          <span>/{{ totalLifts }}</span>
        </div>
      </div>

      <div class="col data-block no-border-block" v-if="showAttractionsBlock">
        <div class="block-title">
          <a href="#attractions" :title="attractionsText">
            <span tabindex="-1">{{ attractionsText }}</span>
          </a>
        </div>
        <div class="block-text">
          <strong>{{ openActivities }}</strong>
          <span>/{{ totalActivities }}</span>
        </div>
      </div>

      <div class="col data-block no-border-block" v-if="showAcresOpenBlock">
        <div class="block-title">
          <span>
            {{ trailsOverviewNames['Acres'] }}
          </span>
        </div>
        <div class="block-text">
          <strong>{{ totalOpenAcres }}</strong>
          <span>/{{ totalAcres }}</span>
        </div>
      </div>

      <div class="col data-block no-border-block" v-if="showAcresOpenPercentBlock">
        <div class="block-title">
          <span>
            {{ trailsOverviewNames['Acres'] }}
          </span>
        </div>
        <div class="block-text">
          <strong>{{ totalOpenAcresPercent }}%</strong>
        </div>
      </div>

      <div class="col data-block no-border-block" v-if="showTerrainParksOpenBlock">
        <div class="block-title">
          <span>{{ trailsOverviewNames['Terrain-Parks'] }}</span>
        </div>
        <div class="block-text">
          <strong>{{ totalOpenTerrainParks }}</strong>
          <span>/{{ totalTerrainParks }}</span>
        </div>
      </div>

      <div class="col data-block groomed-trails-data-block no-border-block" v-if="showGroomedTrailsBlock">
        <div class="block-title">
          <span>{{ trailsOverviewNames['Groomed Trails'] }}</span>
        </div>
        <div class="block-text">
          <strong>{{ totalGroomedTrails }}</strong>
          <span>/{{ totalTrails }}</span>
        </div>
      </div>

      <!-- Summer -->
      <OverviewSections v-if="!isWinterResort" :newsPresent="showNews" />

      <News v-if="showNews" :news="snow_report.News" :newsTitle="newsTitle" />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import News from '@/components/News.vue';
import OverviewSections from '@/components/Summer/OverviewSections.vue';

export default {
  components: {
    News,
    OverviewSections,
  },
  name: 'TrailsOverview',
  props: ['snow_report'],
  computed: {
    ...mapState(['trailsOverviewTitle', 'attractionsText', 'trailsOverviewBlocks', 'trailsOverviewNames', 'newsinTrailsOverview', 'newsTitle']),
    ...mapGetters(['isWinterResort', 'isSummerResort']),
    showTrails() {
      return this.trailsOverviewBlocks.indexOf('TrailsInfo') >= 0;
    },
    showTrailsFirst() {
      return this.trailsOverviewBlocks.indexOf('TrailsInfo') === 0;
    },
    showLifts() {
      return this.trailsOverviewBlocks.indexOf('LiftsInfo') >= 0;
    },
    showLiftsFirst() {
      return this.trailsOverviewBlocks.indexOf('LiftsInfo') === 0;
    },
    showAcresOpenBlock() {
      return this.trailsOverviewBlocks.indexOf('AcresOpenInfo') >= 0;
    },
    showAcresOpenPercentBlock() {
      return this.trailsOverviewBlocks.indexOf('AcresOpenInfoPercent') >= 0;
    },
    showTerrainParksOpenBlock() {
      return this.trailsOverviewBlocks.indexOf('TerrainParksInfo') >= 0;
    },
    showAttractionsBlock() {
      return this.trailsOverviewBlocks.indexOf('ActivitiesInfo') >= 0;
    },
    showGroomedTrailsBlock() {
      return this.trailsOverviewBlocks.indexOf('GroomedTrailsInfo') >= 0;
    },
    showNews() {
      return this.newsPresent && this.newsinTrailsOverview;
    },
    openActivities() {
      if (this.snow_report.TotalOpenActivities) {
        return this.snow_report.TotalOpenActivities;
      }
      return '0';
    },
    totalActivities() {
      if (this.snow_report.TotalActivities) {
        return this.snow_report.TotalActivities;
      }
      return '0';
    },
    totalOpenTrails() {
      if (this.snow_report.TotalOpenTrails) {
        return this.snow_report.TotalOpenTrails;
      }
      return 0;
    },
    totalTrails() {
      if (this.snow_report.TotalTrails) {
        return this.snow_report.TotalTrails;
      }
      return 0;
    },
    totalGroomedTrails() {
      if (this.snow_report.GroomedTrails) {
        return this.snow_report.GroomedTrails;
      }
      return 0;
    },
    totalOpenAcres() {
      if (this.snow_report.OpenTerrainAcres !== '--') {
        return Math.round(this.snow_report.OpenTerrainAcres);
      }
      return 0;
    },
    totalAcres() {
      if (this.snow_report.TotalTerrainAcres) {
        return Math.round(this.snow_report.TotalTerrainAcres);
      }
      return 0;
    },
    totalOpenHectares() {
      if (this.snow_report.OpenTerrainHectares) {
        return this.snow_report.OpenTerrainHectares;
      }
      return 0;
    },
    totalHectares() {
      if (this.snow_report.TotalTerrainHectares) {
        return this.snow_report.TotalTerrainHectares;
      }
      return 0;
    },
    totalOpenAcresPercent() {
      if (this.snow_report.OpenTerrainAcres !== '--') {
        return Math.round((this.totalOpenAcres / this.totalAcres) * 100);
      }
      return '0';
    },
    totalOpenLifts() {
      if (this.snow_report.TotalOpenLifts) {
        return this.snow_report.TotalOpenLifts;
      }
      return 0;
    },
    totalLifts() {
      if (this.snow_report.TotalLifts) {
        return this.snow_report.TotalLifts;
      }
      return 0;
    },
    totalOpenTerrainParks() {
      if (this.snow_report.TotalOpenParks) {
        return this.snow_report.TotalOpenParks;
      }
      return 0;
    },
    totalTerrainParks() {
      if (this.snow_report.TotalParks) {
        return this.snow_report.TotalParks;
      }
      return 0;
    },
    newsPresent() {
      return this.snow_report.News !== '--';
    },
  },
};
</script>

<style lang="scss" scoped>
.trails-overview {
  &.summer-trails-overview {
    min-height: 200px;
  }
}
.main-block {
  border-right: none;
  margin-bottom: 20px;
  .block-text {
    color: $brand-gray;
    font-size: 62px;
    line-height: 1.2;
    margin: -10px 0 0;
  }
}
.no-border-block {
  @media (max-width: $tablet-landscape) {
    border-right: none;
  }
}
</style>
